/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'titulo-dashboard',
    title: 'nav.groups.bookkeeping.title',
    subtitle: 'nav.groups.bookkeeping.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'userdashboard',
    title: 'nav.items.dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: 'user/dashboard',
  },
  {
    id: 'userworkers',
    title: 'nav.items.workers',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: 'user/workers',
  },
  {
    id: 'userproviders',
    title: 'nav.items.providers',
    type: 'basic',
    icon: 'heroicons_outline:archive-box-arrow-down',
    link: 'user/providers',
  },
  {
    id: 'uservehicles',
    title: 'nav.items.vehicles',
    type: 'basic',
    icon: 'heroicons_outline:truck',
    link: 'user/vehicles',
  },
  {
    id: 'userbankaccounts',
    title: 'nav.items.bankAccounts',
    type: 'basic',
    icon: 'heroicons_outline:building-library',
    link: 'user/bankaccounts',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'userloans',
    title: 'nav.items.loans',
    type: 'basic',
    icon: 'heroicons_outline:banknotes',
    link: 'user/loans',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'usercategories',
    title: 'nav.items.categories',
    type: 'basic',
    icon: 'heroicons_outline:list-bullet',
    link: 'user/categories',
  },
  {
    id: 'usersubcategories',
    title: 'nav.items.subcategories',
    type: 'basic',
    icon: 'heroicons_outline:queue-list',
    link: 'user/subcategories',
  },
  {
    id: 'titulo-importacion-datos',
    title: 'nav.groups.dataImport.title',
    subtitle: 'nav.groups.dataImport.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'importacion-datos',
    title: 'nav.items.dataImport',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    link: 'user/dataimport',
  },
  {
    id: 'titulo-reportes',
    title: 'nav.groups.reports.title',
    subtitle: 'nav.groups.reports.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'reportes',
    title: 'nav.items.reports',
    type: 'basic',
    icon: 'heroicons_outline:document-magnifying-glass',
    link: 'user/detailed-reports',
  },
  {
    id: 'titulo-facturas',
    title: 'nav.groups.bills.title',
    subtitle: 'nav.groups.bills.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'facturas',
    title: 'nav.items.bills',
    icon: 'heroicons_outline:clipboard-document-list',
    type: 'collapsable',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
    children: [
      {
        id: 'userclients',
        title: 'nav.items.clients',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: 'user/clients',
      },
      {
        id: 'userproducts',
        title: 'nav.items.products',
        type: 'basic',
        icon: 'heroicons_outline:shopping-bag',
        link: 'user/products',
      },
      {
        id: 'userbills',
        title: 'nav.items.bills',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: 'user/bills',
      },
    ],
  },
  {
    id: 'titulo-cursos',
    title: 'nav.groups.courses.title',
    subtitle: 'nav.groups.courses.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'academy',
    title: 'nav.items.courses',
    type: 'basic',
    icon: 'heroicons_outline:academic-cap',
    link: 'user/cursos',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-help-center',
    title: 'nav.groups.support.title',
    subtitle: 'nav.groups.support.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'help-center',
    title: 'nav.items.helpCenter',
    type: 'basic',
    icon: 'heroicons_outline:chat-bubble-left-right',
    link: 'user/help-center',
  },
];

export const adminNavigation: FuseNavigationItem[] = [
  {
    id: 'titulo-admin-dashboard',
    title: 'nav.groups.admin.title',
    subtitle: 'nav.groups.admin.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'dashboard',
    title: 'nav.items.dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/dashboard',
  },
  {
    id: 'users',
    title: 'nav.items.users',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/users',
  },
  {
    id: 'privacyrequests',
    title: 'nav.items.privacyRequests',
    type: 'basic',
    icon: 'heroicons_outline:shield-check',
    link: '/privacyrequests',
  },
  {
    id: 'categories',
    title: 'nav.items.categories',
    type: 'basic',
    icon: 'heroicons_outline:list-bullet',
    link: '/categories',
  },
  {
    id: 'subcategories',
    title: 'nav.items.subcategories',
    type: 'basic',
    icon: 'heroicons_outline:queue-list',
    link: '/subcategories',
  },
  {
    id: 'titulo-admin-cursos',
    title: 'nav.groups.adminCourses.title',
    subtitle: 'nav.groups.adminCourses.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'cursos',
    title: 'nav.items.courses',
    type: 'basic',
    icon: 'heroicons_outline:queue-list',
    link: '/cursos',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-usuario-dashboard',
    title: 'nav.groups.userBookkeeping.title',
    subtitle: 'nav.groups.userBookkeeping.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'userdashboard',
    title: 'nav.items.userDashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: 'user/dashboard',
  },
  {
    id: 'userworkers',
    title: 'nav.items.workers',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: 'user/workers',
  },
  {
    id: 'userproviders',
    title: 'nav.items.providers',
    type: 'basic',
    icon: 'heroicons_outline:archive-box-arrow-down',
    link: 'user/providers',
  },
  {
    id: 'uservehicles',
    title: 'nav.items.vehicles',
    type: 'basic',
    icon: 'heroicons_outline:truck',
    link: 'user/vehicles',
  },
  {
    id: 'userbankaccounts',
    title: 'nav.items.bankAccounts',
    type: 'basic',
    icon: 'heroicons_outline:building-library',
    link: 'user/bankaccounts',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'userloans',
    title: 'nav.items.loans',
    type: 'basic',
    icon: 'heroicons_outline:banknotes',
    link: 'user/loans',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-usuario-facturas',
    title: 'nav.groups.userBills.title',
    subtitle: 'nav.groups.userBills.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'facturas',
    title: 'nav.items.bills',
    icon: 'heroicons_outline:clipboard-document-list',
    type: 'collapsable',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
    children: [
      {
        id: 'userclients',
        title: 'nav.items.clients',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: 'user/clients',
      },
      {
        id: 'userproducts',
        title: 'nav.items.products',
        type: 'basic',
        icon: 'heroicons_outline:shopping-bag',
        link: 'user/products',
      },
      {
        id: 'userbills',
        title: 'nav.items.bills',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: 'user/bills',
      },
    ],
  },
  {
    id: 'titulo-usuario-importacion-datos',
    title: 'nav.groups.userDataImport.title',
    subtitle: 'nav.groups.userDataImport.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'user-dataimport',
    title: 'nav.items.dataImport',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    link: 'user/dataimport',
  },
  {
    id: 'titulo-usuario-reportes',
    title: 'nav.groups.userReports.title',
    subtitle: 'nav.groups.userReports.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'user-reportes',
    title: 'nav.items.reports',
    type: 'basic',
    icon: 'heroicons_outline:document-magnifying-glass',
    link: 'user/detailed-reports',
  },
  // ----------------- User Listas de anos y meses -----------------
  // {
  //   id: "usertaxyears",
  //   title: "Usuario Años de impuestos",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/taxyears",
  // },
  // {
  //   id: "usertaxmonths",
  //   title: "Usuarios Meses de impuestos",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/taxmonths",
  // },
  // ------------------------------------------
  // {
  //   id: "usermonthdashboard",
  //   title: "Usuarios dashboard de mes",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/monthdashboard",
  // },
  // {
  //   id: "userdailyincome",
  //   title: "Usuario Ingresos diarios",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/dailyincome",
  // },
  // {
  //   id: "userpurchasedproducts",
  //   title: "Usuario Compras de productos",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/purchasedproducts",
  // },
  // {
  //   id: "userworkerspayment",
  //   title: "Usuario Pago de trabajadores (1099)",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/workerspayment",
  // },
  // {
  //   id: "userprofitsandlossesmonth",
  //   title: "Usuario Ganancias y pérdidas del mes",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/profitsandlossesmonth",
  // },
  // {
  //   id: "useroperationalexpenses",
  //   title: "Usuario Gastos operacionales",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/operationalexpenses",
  // },
  // {
  //   id: "usermonthlymileage",
  //   title: "Usuario Millaje mensual",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/monthlymileage",
  // },
  // {
  //   id: "userannualtotal",
  //   title: "Usuario Total anual",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/annualtotal",
  // },
  {
    id: 'titulo-usuario-cursos',
    title: 'nav.groups.courses.title',
    subtitle: 'nav.groups.courses.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'admin-academy',
    title: 'nav.items.courses',
    type: 'basic',
    icon: 'heroicons_outline:academic-cap',
    link: 'user/cursos',
    badge: {
      title: 'nav.badges.new',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-usuario-soporte',
    title: 'nav.groups.userSupport.title',
    subtitle: 'nav.groups.userSupport.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'help-center',
    title: 'nav.items.helpCenter',
    type: 'basic',
    icon: 'heroicons_outline:chat-bubble-left-right',
    link: 'user/help-center',
  },
  {
    id: 'titulo-revision',
    title: 'nav.groups.review.title',
    subtitle: 'nav.groups.review.subtitle',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    // The purchase screens as the user sees them, so an admin can check their
    // content without buying anything (the confirmation renders as a preview
    // when there is no payment token in the URL).
    id: 'review',
    title: 'nav.items.purchaseScreens',
    type: 'collapsable',
    icon: 'heroicons_outline:eye',
    children: [
      {
        id: 'pricing',
        title: 'nav.items.pricing',
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: 'user/pricing',
      },
      {
        id: 'purchaseconfirmation',
        title: 'nav.items.purchaseConfirmation',
        type: 'basic',
        icon: 'heroicons_outline:check-badge',
        link: 'user/purchaseconfirmation',
      },
      {
        id: 'purchaseerror',
        title: 'nav.items.purchaseError',
        type: 'basic',
        icon: 'heroicons_outline:exclamation-triangle',
        link: 'user/purchaseerror',
      },
    ],
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
